import React, { createContext, useContext, useState, useCallback } from 'react';

const GrnDetailContext = createContext(null);

export const GrnDetailProvider = ({ children }) => {
  const [grnData, setGrnData] = useState(null);

  const updateGrnData = useCallback(data => {
    setGrnData(data);
  }, []);

  return (
    <GrnDetailContext.Provider value={{ grnData, updateGrnData }}>
      {children}
    </GrnDetailContext.Provider>
  );
};

export const useGrnDetailContext = () => useContext(GrnDetailContext);

export default GrnDetailProvider;
